import { useSelector } from 'react-redux';
import { selectGiftCardsBasket } from '../../store/slices/GiftCardBasketSlice';
import { useMemo } from 'react';

export const useGiftCardsBasket = () => {
  const item = useSelector(selectGiftCardsBasket);

  const total = useMemo(() => (item ? (item.value / 100) * item.quantity : 0), [item]);

  return { item, total };
};
